export default "https://cdn-static.gokick.com/assets/9df01a4d731a00226137dd4d749df43ffc1d6e8e/images/sleep-blueberry.4c08b7b0b460cc7a3bc9f6ddf7107552.png";